var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_line/Star_rectangle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 14 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 9.19036C2.5 5.62352 5.29822 2.73203 8.75 2.73203H21.25C24.7018 2.73203 27.5 5.62352 27.5 9.19036V22.107C27.5 25.6739 24.7018 28.5654 21.25 28.5654H8.75C5.29822 28.5654 2.5 25.6739 2.5 22.107V9.19036ZM8.75 5.31536C6.67893 5.31536 5 7.05026 5 9.19036V22.107C5 24.2471 6.67893 25.982 8.75 25.982H21.25C23.3211 25.982 25 24.2471 25 22.107V9.19036C25 7.05026 23.3211 5.31536 21.25 5.31536H8.75Z",
    fill: "url(#paint0_linear_1_399)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 1 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3935 9.4438C14.1223 8.19252 15.8778 8.19252 16.6065 9.4438L17.8552 11.5878L20.2144 12.1524C21.5913 12.482 22.1338 14.2072 21.2073 15.3101L19.6198 17.1998L19.8292 19.6928C19.9514 21.1477 18.5311 22.214 17.2298 21.6443L15 20.6681L12.7702 21.6443C11.4689 22.214 10.0487 21.1477 10.1709 19.6928L10.3802 17.1998L8.79277 15.3101C7.86632 14.2072 8.40881 12.482 9.78565 12.1524L12.1448 11.5878L13.3935 9.4438ZM15 11.6953L14.1503 13.1543C13.8885 13.6038 13.4615 13.9244 12.9669 14.0428L11.3615 14.427L12.4417 15.7129C12.7746 16.1091 12.9377 16.6279 12.8938 17.1505L12.7513 18.847L14.2686 18.1827C14.7361 17.9781 15.264 17.9781 15.7315 18.1827L17.2488 18.847L17.1063 17.1505C17.0624 16.6279 17.2255 16.1091 17.5583 15.7129L18.6386 14.427L17.0332 14.0428C16.5386 13.9244 16.1115 13.6038 15.8497 13.1543L15 11.6953Z",
    fill: "url(#paint1_linear_1_399)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_399",
    x1: 2.92049,
    y1: 2.73202,
    x2: 28.0366,
    y2: 3.2647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076B9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_399",
    x1: 8.55657,
    y1: 8.50534,
    x2: 21.9536,
    y2: 8.79983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076B9E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServices);
export default __webpack_public_path__ + "static/media/icon_services.4beec0db7bec198c16f57badb0d7b877.svg";
export { ForwardRef as ReactComponent };